import get from "lodash-es/get";
import has from "lodash-es/has";

export function normalizeGraphqlErrors(errors, fieldsWithError) {
  if (!errors || !errors.length) return;

  const formErrors = {};
  const snackBarErrors = [];

  const appendErrors = (error) => {
    const errorFormPath = error.path.slice(1).join(".");
    if (!!errorFormPath && fieldsWithError.includes(errorFormPath)) {
      formErrors[errorFormPath] = error.message;
    } else {
      snackBarErrors.push(error.message);
    }
  };

  const parseExtensionsErrors = (error) => {
    get(error, "extensions.errors", []).forEach((err) => {
      appendErrors(err);
    });
  };

  errors.forEach((error) => {
    if (has(error, "extensions.errors")) {
      parseExtensionsErrors(error);
      return;
    }
    appendErrors(error);
  });
  return { formErrors, snackBarErrors };
}
